/*
 * File: index.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on March 10, 2025 at 12:59 PM
 * Copyright © 2025 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: June 5, 2025 at 12:53 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Utilities
import { api } from '../api';

// Constants
const { PARSE_MOUNT } = process.env;


/**
 * Services
 */

export const fetchResources = ({ page, sortBy, isFeatured } = {}) => api.post(`${PARSE_MOUNT}/functions/fetchResourcesDirectory`, { page, sort_by: sortBy, is_featured: isFeatured });

export const fetchResource = ({ slug } = {}) => api.post(`${PARSE_MOUNT}/functions/fetchResource`, { slug });

export const fetchResourcePrompts = () => api.post(`${PARSE_MOUNT}/functions/fetchResourcePrompts`);

export const fetchResourcePrompt = ({ slug } = {}) => api.post(`${PARSE_MOUNT}/functions/fetchResourcePrompt`, { slug });

export const fetchResourceLocale = ({ country, region } = {}) => api.post(`${PARSE_MOUNT}/functions/fetchResourceLocale`, { country, region });

export const getResourceManifest = () => api.get('/_api/resources');
